import { Box } from '@televet/kibble-ui/build/chakra';
import { WidgetRequestAnswerSummary } from 'pages/Conversations/components/ChannelMessage/MessageGroup/WidgetRequestAnswerSummary';
import React from 'react';
import LoadingSpinner from 'shared/components/LoadingSpinner';
import { GraphQLFetchPolicies } from 'shared/enums';
import { useGetClinicWidgetRequestQuery } from 'shared/types/graphql';

type TaskDetailWidgetRequestProps = {
  widgetRequestId?: string | null;
  phoneNumber?: string | null;
  borderLeftColor?: string;
};

const TaskDetailWidgetRequest = ({
  widgetRequestId,
  phoneNumber,
  borderLeftColor,
}: TaskDetailWidgetRequestProps): JSX.Element => {
  const { data: widgetRequestData, loading } = useGetClinicWidgetRequestQuery({
    variables: { where: { id: widgetRequestId } },
    fetchPolicy: GraphQLFetchPolicies.CacheFirst,
  });

  if (loading) {
    return (
      <Box>
        <LoadingSpinner direction="row" />
      </Box>
    );
  }
  return (
    <WidgetRequestAnswerSummary
      primaryPhoneNumber={phoneNumber || ''}
      widgetRequestData={widgetRequestData}
      small={true}
      borderLeftColor={borderLeftColor}
    />
  );
};

export default TaskDetailWidgetRequest;
